var Alberta = "Alberta";
var Manitoba = "Manitoba";
var Nunavut = "Nunavut";
var Ontario = "Ontario";
var Quebec = "Quebec";
var Saskatchewan = "Saskatchewan";
var Yukon = "Yukón";
var CAStates = {
	Alberta: Alberta,
	"British Columbia": "Columbia Británica",
	Manitoba: Manitoba,
	"New Brunswick": "New Brunswick",
	"Newfoundland and Labrador": "Terranova y Labrador",
	"Northwest Territories": "Territorios del Noroeste",
	"Nova Scotia": "Nueva Escocia",
	Nunavut: Nunavut,
	Ontario: Ontario,
	"Prince Edward Island": "Isla del Príncipe Eduardo",
	Quebec: Quebec,
	Saskatchewan: Saskatchewan,
	Yukon: Yukon
};

export { Alberta, Manitoba, Nunavut, Ontario, Quebec, Saskatchewan, Yukon, CAStates as default };
